import { render, staticRenderFns } from "./GalleryWriteLink.vue?vue&type=template&id=16bcd9f5&scoped=true"
import script from "./GalleryWriteLink.vue?vue&type=script&lang=js"
export * from "./GalleryWriteLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bcd9f5",
  null
  
)

export default component.exports